/* eslint-disable */
import * as helpers from '@/store/modules/schedule/helpers'
import _ from 'lodash'

export const getters = {
  filteredSchedule: (state) => {
    let preSortSchedule = state.schedule.filter(
      helpers.filterShedule(
        state.filter.carCallSign ?? '',
        state.filter.carNumber ?? '',
        state.filter.carModel ?? ''
      )
    )

    if (typeof state.filter?.indicators?.is_working !== 'undefined') {
      preSortSchedule = helpers.filtredByIndicatorIsWorking(state, preSortSchedule)
    }
    if (state.filter?.FIO) {
      preSortSchedule = helpers.filtredByDriverName(state, preSortSchedule)
    }
    if (state?.ignoringDriverWorking?.length > 0) {
      console.log(state?.ignoringDriverWorking)
      state.ignoringDriverWorking = helpers.deleteDriversIfExpDateLost(state.ignoringDriverWorking)
      preSortSchedule = helpers.reduceByIgnoreListIndicatorsIsWorking(state, preSortSchedule)
    }
    if (state.filter.loadSort) {
      preSortSchedule = _.sortBy(preSortSchedule, ({ dates }) => {
        let loadLevel = 0

        for (const date in dates) {
          if (dates[date].day !== null) loadLevel++
          if (dates[date].night !== null) loadLevel++
        }

        return loadLevel
      })

      preSortSchedule = _.reverse(preSortSchedule)
    }
    if (state.filter.modelSort) {
      preSortSchedule = _.sortBy(preSortSchedule, (object) => {
        return object.carModel
      })
    }
    return preSortSchedule
  },

  getFilteredDrivers: (state) => {
    // неюзабельный геттер
    const newDrivers = JSON.parse(JSON.stringify(state.availableDrivers))
    return newDrivers.filter(helpers.searchDriver(state.filter.last_name))
  },
  getFirstMiddleLastNames: (state, getters) => {
    const getNameByObj = (obj) => {
      if (!obj) return;
      const { driverLastName, driverMiddleName, driverFirstName } = obj;
      return {
        name: `${driverLastName || ''} ${driverFirstName || ''} ${driverMiddleName || ''}`,
        id: obj.driverId
      }
    }

    const uniqueNames = {}

    getters.filteredSchedule.forEach(value => {
      const getDates = value.dates
      const getDatesKeys = Object.keys(getDates)
      if (!getDatesKeys?.length) return


      getDatesKeys.forEach(dateKey => {
        const dayNameObj = getNameByObj(getDates[dateKey]?.day)
        const nightNameObj = getNameByObj(getDates[dateKey]?.night)
        const fulldayNameObj = getNameByObj(getDates[dateKey]?.fullDay)

        if (dayNameObj && dayNameObj.name) {
          uniqueNames[dayNameObj.name] = dayNameObj
        }
        if (nightNameObj && nightNameObj.name) {
          uniqueNames[nightNameObj.name] = nightNameObj
        }
        if (fulldayNameObj && fulldayNameObj.name) {
          uniqueNames[fulldayNameObj.name] = fulldayNameObj
        }
      })
    })

    return Object.values(uniqueNames)
  },
  getCars: (state) => {
    return state.schedule.map((element) => {
      return {
        car_callsign: element.carCallSign,
        car_id: element.carId,
        car_model: element.carModel,
        car_number: element.carNumber
      }
    })
  },
  getCurrentDriversOnThePark: (state, getters) => {
    if (!state.currentRegionParkID) return state.availableDrivers
    return state.availableDrivers.filter(driver => driver.regionParkId === state.currentRegionParkID)
  },
  getNotAssignedDrivers: (state, getters) => {
    return state.availableDrivers.filter(driver => driver.regionParkId === '00000000-0000-0000-0000-000000000000')
  },
  getDetachedParkDrivers: (state, getters) => {
    return state.availableDrivers.filter(driver => driver.detachedPark === true)
  },
  findDriverInChangeByName: (state) => (name) => {
    return state.driversInChange.filter(driver => {
      const driverName = driver.driverFullName.toLowerCase()

      return driverName.includes(name.toLowerCase())
    })
  }
}
